// extracted by mini-css-extract-plugin
module.exports = {"buttons":"AddLoanLeaseCoverage_buttons__9wSuC"};